export const selectButtonDisabled = (state: any) =>
  !!state.assetInventoryViewModel?.asset_inventory?.button_disabled;

export const selectShowScheduleJobButton = (state: any) =>
  !!state.assetInventoryViewModel?.asset_inventory?.show_schedule_job_button;
